export default __webpack_public_path__ + "static/media/download-16px.e895632d.svg";